//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;

    return `${finalBaseUrl}${prefix}`;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      let apiKey: string;
      if (this.configuration.apiKeyPromise) {
        apiKey = await this.configuration.apiKeyPromise();
      } else {
        apiKey = this.configuration.apiKey;
      }
      (options.headers as any)["authorization"] = apiKey;
      if (this.configuration.headers) {
        options.headers = {
          ...options.headers,
          ...this.configuration.headers,
        };
      }
      for (const middleware of this.configuration.middlewares) {
        options = (await middleware.pre(options)) || options;
      }
    }

    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    // is there middlware in configuration
    for (const middleware of this.configuration.middlewares) {
      response = (await middleware.post(response)) || response;
    }

    return processor(response);
  }
}

export interface ICentreApi {

    getCentresByCurrentUser(): Promise<CentreDto[]>;
}

export class CentreApi extends BaseAPI implements ICentreApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCentresByCurrentUser(): Promise<CentreDto[]> {
        let url_ = this.baseUrl + "/api/Centre/by-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCentresByCurrentUser(_response));
        });
    }

    protected processGetCentresByCurrentUser(response: Response): Promise<CentreDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CentreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CentreDto[]>(null as any);
    }
}

export interface IClasseHoraireApi {

    getClasseHorairesByCurrentUser(): Promise<ClasseHoraireDto[]>;

    getDefaultClasseHoraireByCurrentUser(): Promise<ClasseHoraireDto>;

    saveADistance(idclasseHoraire: number | undefined, newValue: boolean | undefined): Promise<FileResponse>;
}

export class ClasseHoraireApi extends BaseAPI implements IClasseHoraireApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getClasseHorairesByCurrentUser(): Promise<ClasseHoraireDto[]> {
        let url_ = this.baseUrl + "/api/ClasseHoraire/by-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClasseHorairesByCurrentUser(_response));
        });
    }

    protected processGetClasseHorairesByCurrentUser(response: Response): Promise<ClasseHoraireDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClasseHoraireDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClasseHoraireDto[]>(null as any);
    }

    getDefaultClasseHoraireByCurrentUser(): Promise<ClasseHoraireDto> {
        let url_ = this.baseUrl + "/api/ClasseHoraire/default-by-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaultClasseHoraireByCurrentUser(_response));
        });
    }

    protected processGetDefaultClasseHoraireByCurrentUser(response: Response): Promise<ClasseHoraireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClasseHoraireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClasseHoraireDto>(null as any);
    }

    saveADistance(idclasseHoraire: number | undefined, newValue: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClasseHoraire/save-a-distance?";
        if (idclasseHoraire === null)
            throw new Error("The parameter 'idclasseHoraire' cannot be null.");
        else if (idclasseHoraire !== undefined)
            url_ += "idclasseHoraire=" + encodeURIComponent("" + idclasseHoraire) + "&";
        if (newValue === null)
            throw new Error("The parameter 'newValue' cannot be null.");
        else if (newValue !== undefined)
            url_ += "newValue=" + encodeURIComponent("" + newValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveADistance(_response));
        });
    }

    protected processSaveADistance(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPresenceApi {

    getPresencesByClasseHoraire(classeHoraireId: number | undefined): Promise<SavePresenceDto>;

    savePresences(dto: SavePresenceDto): Promise<number>;
}

export class PresenceApi extends BaseAPI implements IPresenceApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPresencesByClasseHoraire(classeHoraireId: number | undefined): Promise<SavePresenceDto> {
        let url_ = this.baseUrl + "/api/Presence/by-classe-horaire?";
        if (classeHoraireId === null)
            throw new Error("The parameter 'classeHoraireId' cannot be null.");
        else if (classeHoraireId !== undefined)
            url_ += "classeHoraireId=" + encodeURIComponent("" + classeHoraireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPresencesByClasseHoraire(_response));
        });
    }

    protected processGetPresencesByClasseHoraire(response: Response): Promise<SavePresenceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePresenceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavePresenceDto>(null as any);
    }

    savePresences(dto: SavePresenceDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Presence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePresences(_response));
        });
    }

    protected processSavePresences(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ISystemApi {

    get(): Promise<SystemInfoDto>;

    getExposedTypes(): Promise<ExposedTypes>;

    geFrontendSettings(): Promise<FrontendSettings>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemInfoDto>(null as any);
    }

    getExposedTypes(): Promise<ExposedTypes> {
        let url_ = this.baseUrl + "/api/System/exposed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExposedTypes(_response));
        });
    }

    protected processGetExposedTypes(response: Response): Promise<ExposedTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExposedTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExposedTypes>(null as any);
    }

    geFrontendSettings(): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/api/System/fe-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeFrontendSettings(_response));
        });
    }

    protected processGeFrontendSettings(response: Response): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }
}

export interface IUserApi {

    getProfile(): Promise<UserProfileDto>;

    logout(): Promise<FileResponse>;
}

export class UserApi extends BaseAPI implements IUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getProfile(): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProfile(_response));
        });
    }

    protected processGetProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    logout(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(): Promise<HealthCheckViewModel>;

    getStartupHealthCheck(): Promise<HealthCheckViewModel>;

    getReadyHealthCheck(): Promise<HealthCheckViewModel>;

    getLiveHealthCheck(): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getStartupHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStartupHealthCheck(_response));
        });
    }

    protected processGetStartupHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getReadyHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReadyHealthCheck(_response));
        });
    }

    protected processGetReadyHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getLiveHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLiveHealthCheck(_response));
        });
    }

    protected processGetLiveHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export interface IApiKeyApi {

    getApiKey(clientName: string | null | undefined): Promise<ClientApiKey>;
}

export class ApiKeyApi extends BaseAPI implements IApiKeyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApiKey(clientName: string | null | undefined): Promise<ClientApiKey> {
        let url_ = this.baseUrl + "/apikey?";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiKey(_response));
        });
    }

    protected processGetApiKey(response: Response): Promise<ClientApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientApiKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientApiKey>(null as any);
    }
}

export class CentreDto implements ICentreDto {
    idcentre?: number;
    nom?: string | undefined;

    constructor(data?: ICentreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcentre = _data["idcentre"];
            this.nom = _data["nom"];
        }
    }

    static fromJS(data: any): CentreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CentreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcentre"] = this.idcentre;
        data["nom"] = this.nom;
        return data;
    }

    clone(): CentreDto {
        const json = this.toJSON();
        let result = new CentreDto();
        result.init(json);
        return result;
    }
}

export interface ICentreDto {
    idcentre?: number;
    nom?: string | undefined;
}

export class ClasseHoraireDto implements IClasseHoraireDto {
    idclasseHoraire?: number;
    jourLabel?: string | undefined;
    jour?: string | undefined;
    heureDebut?: string | undefined;
    heureFin?: string | undefined;
    heureLabel?: string | undefined;
    classeHoraireDebut?: Date;
    classeHoraireFin?: Date;
    idclasse?: number;
    nomClasse?: string | undefined;
    codeClasse?: string | undefined;
    idcentre?: number;
    nomCentre?: string | undefined;
    idclasseMatiere?: number;
    codeClasseMatiere?: string | undefined;
    nomClasseMatiere?: string | undefined;
    presenceComplete?: boolean;

    constructor(data?: IClasseHoraireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idclasseHoraire = _data["idclasseHoraire"];
            this.jourLabel = _data["jourLabel"];
            this.jour = _data["jour"];
            this.heureDebut = _data["heureDebut"];
            this.heureFin = _data["heureFin"];
            this.heureLabel = _data["heureLabel"];
            this.classeHoraireDebut = _data["classeHoraireDebut"] ? new Date(_data["classeHoraireDebut"].toString()) : <any>undefined;
            this.classeHoraireFin = _data["classeHoraireFin"] ? new Date(_data["classeHoraireFin"].toString()) : <any>undefined;
            this.idclasse = _data["idclasse"];
            this.nomClasse = _data["nomClasse"];
            this.codeClasse = _data["codeClasse"];
            this.idcentre = _data["idcentre"];
            this.nomCentre = _data["nomCentre"];
            this.idclasseMatiere = _data["idclasseMatiere"];
            this.codeClasseMatiere = _data["codeClasseMatiere"];
            this.nomClasseMatiere = _data["nomClasseMatiere"];
            this.presenceComplete = _data["presenceComplete"];
        }
    }

    static fromJS(data: any): ClasseHoraireDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClasseHoraireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idclasseHoraire"] = this.idclasseHoraire;
        data["jourLabel"] = this.jourLabel;
        data["jour"] = this.jour;
        data["heureDebut"] = this.heureDebut;
        data["heureFin"] = this.heureFin;
        data["heureLabel"] = this.heureLabel;
        data["classeHoraireDebut"] = this.classeHoraireDebut ? this.classeHoraireDebut.toISOString() : <any>undefined;
        data["classeHoraireFin"] = this.classeHoraireFin ? this.classeHoraireFin.toISOString() : <any>undefined;
        data["idclasse"] = this.idclasse;
        data["nomClasse"] = this.nomClasse;
        data["codeClasse"] = this.codeClasse;
        data["idcentre"] = this.idcentre;
        data["nomCentre"] = this.nomCentre;
        data["idclasseMatiere"] = this.idclasseMatiere;
        data["codeClasseMatiere"] = this.codeClasseMatiere;
        data["nomClasseMatiere"] = this.nomClasseMatiere;
        data["presenceComplete"] = this.presenceComplete;
        return data;
    }

    clone(): ClasseHoraireDto {
        const json = this.toJSON();
        let result = new ClasseHoraireDto();
        result.init(json);
        return result;
    }
}

export interface IClasseHoraireDto {
    idclasseHoraire?: number;
    jourLabel?: string | undefined;
    jour?: string | undefined;
    heureDebut?: string | undefined;
    heureFin?: string | undefined;
    heureLabel?: string | undefined;
    classeHoraireDebut?: Date;
    classeHoraireFin?: Date;
    idclasse?: number;
    nomClasse?: string | undefined;
    codeClasse?: string | undefined;
    idcentre?: number;
    nomCentre?: string | undefined;
    idclasseMatiere?: number;
    codeClasseMatiere?: string | undefined;
    nomClasseMatiere?: string | undefined;
    presenceComplete?: boolean;
}

export class SavePresenceDto implements ISavePresenceDto {
    idClasseHoraire?: number;
    presenceFormateurs?: PresenceFormateurDto[] | undefined;
    presences?: PresenceDto[] | undefined;
    idFormateurUser?: number | undefined;
    aDistance?: boolean;

    constructor(data?: ISavePresenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idClasseHoraire = _data["idClasseHoraire"];
            if (Array.isArray(_data["presenceFormateurs"])) {
                this.presenceFormateurs = [] as any;
                for (let item of _data["presenceFormateurs"])
                    this.presenceFormateurs!.push(PresenceFormateurDto.fromJS(item));
            }
            if (Array.isArray(_data["presences"])) {
                this.presences = [] as any;
                for (let item of _data["presences"])
                    this.presences!.push(PresenceDto.fromJS(item));
            }
            this.idFormateurUser = _data["idFormateurUser"];
            this.aDistance = _data["aDistance"];
        }
    }

    static fromJS(data: any): SavePresenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePresenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idClasseHoraire"] = this.idClasseHoraire;
        if (Array.isArray(this.presenceFormateurs)) {
            data["presenceFormateurs"] = [];
            for (let item of this.presenceFormateurs)
                data["presenceFormateurs"].push(item.toJSON());
        }
        if (Array.isArray(this.presences)) {
            data["presences"] = [];
            for (let item of this.presences)
                data["presences"].push(item.toJSON());
        }
        data["idFormateurUser"] = this.idFormateurUser;
        data["aDistance"] = this.aDistance;
        return data;
    }

    clone(): SavePresenceDto {
        const json = this.toJSON();
        let result = new SavePresenceDto();
        result.init(json);
        return result;
    }
}

export interface ISavePresenceDto {
    idClasseHoraire?: number;
    presenceFormateurs?: PresenceFormateurDto[] | undefined;
    presences?: PresenceDto[] | undefined;
    idFormateurUser?: number | undefined;
    aDistance?: boolean;
}

export class PresenceFormateurDto implements IPresenceFormateurDto {
    idpresenceFormateur?: number;
    idclasseHoraire?: number;
    idformateur?: number;
    principal?: boolean | undefined;
    statut?: string | undefined;
    formateur?: string | undefined;

    constructor(data?: IPresenceFormateurDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpresenceFormateur = _data["idpresenceFormateur"];
            this.idclasseHoraire = _data["idclasseHoraire"];
            this.idformateur = _data["idformateur"];
            this.principal = _data["principal"];
            this.statut = _data["statut"];
            this.formateur = _data["formateur"];
        }
    }

    static fromJS(data: any): PresenceFormateurDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceFormateurDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpresenceFormateur"] = this.idpresenceFormateur;
        data["idclasseHoraire"] = this.idclasseHoraire;
        data["idformateur"] = this.idformateur;
        data["principal"] = this.principal;
        data["statut"] = this.statut;
        data["formateur"] = this.formateur;
        return data;
    }

    clone(): PresenceFormateurDto {
        const json = this.toJSON();
        let result = new PresenceFormateurDto();
        result.init(json);
        return result;
    }
}

export interface IPresenceFormateurDto {
    idpresenceFormateur?: number;
    idclasseHoraire?: number;
    idformateur?: number;
    principal?: boolean | undefined;
    statut?: string | undefined;
    formateur?: string | undefined;
}

export class PresenceDto implements IPresenceDto {
    contrat?: string | undefined;
    apprenant?: string | undefined;
    idinscription?: number | undefined;
    idapprenant?: number | undefined;
    statut?: string | undefined;
    idclasseHoraire?: number | undefined;
    idpresence?: number | undefined;

    constructor(data?: IPresenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contrat = _data["contrat"];
            this.apprenant = _data["apprenant"];
            this.idinscription = _data["idinscription"];
            this.idapprenant = _data["idapprenant"];
            this.statut = _data["statut"];
            this.idclasseHoraire = _data["idclasseHoraire"];
            this.idpresence = _data["idpresence"];
        }
    }

    static fromJS(data: any): PresenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PresenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contrat"] = this.contrat;
        data["apprenant"] = this.apprenant;
        data["idinscription"] = this.idinscription;
        data["idapprenant"] = this.idapprenant;
        data["statut"] = this.statut;
        data["idclasseHoraire"] = this.idclasseHoraire;
        data["idpresence"] = this.idpresence;
        return data;
    }

    clone(): PresenceDto {
        const json = this.toJSON();
        let result = new PresenceDto();
        result.init(json);
        return result;
    }
}

export interface IPresenceDto {
    contrat?: string | undefined;
    apprenant?: string | undefined;
    idinscription?: number | undefined;
    idapprenant?: number | undefined;
    statut?: string | undefined;
    idclasseHoraire?: number | undefined;
    idpresence?: number | undefined;
}

export class SystemInfoDto implements ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;

    constructor(data?: ISystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): SystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        return data;
    }

    clone(): SystemInfoDto {
        const json = this.toJSON();
        let result = new SystemInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
}

export class ExposedTypes implements IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    resultErrors?: ResultError[] | undefined;

    constructor(data?: IExposedTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : <any>undefined;
            this.errorResult = _data["errorResult"] ? ResultError.fromJS(_data["errorResult"]) : <any>undefined;
            if (Array.isArray(_data["resultErrors"])) {
                this.resultErrors = [] as any;
                for (let item of _data["resultErrors"])
                    this.resultErrors!.push(ResultError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExposedTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ExposedTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : <any>undefined;
        data["errorResult"] = this.errorResult ? this.errorResult.toJSON() : <any>undefined;
        if (Array.isArray(this.resultErrors)) {
            data["resultErrors"] = [];
            for (let item of this.resultErrors)
                data["resultErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExposedTypes {
        const json = this.toJSON();
        let result = new ExposedTypes();
        result.init(json);
        return result;
    }
}

export interface IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
    resultErrors?: ResultError[] | undefined;
}

export enum ActionCode {
    DeleteActionGroup = "DeleteActionGroup",
    EditDataTranslations = "EditDataTranslations",
    EditRoles = "EditRoles",
    EditUser = "EditUser",
    EditTranslations = "EditTranslations",
    EditAction = "EditAction",
    EditActionGroup = "EditActionGroup",
    ViewData = "ViewData",
    ViewUserActions = "ViewUserActions",
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.exceptionType = _data["exceptionType"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["exceptionType"] = this.exceptionType;
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ValueObject {
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }
}

export interface IValueObject {
}

export class ResultError extends ValueObject implements IResultError {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;

    constructor(data?: IResultError) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.hasPropertyName = _data["hasPropertyName"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorLevel = _data["errorLevel"];
            this.invalidValue = _data["invalidValue"];
        }
    }

    static fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["hasPropertyName"] = this.hasPropertyName;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorLevel"] = this.errorLevel;
        data["invalidValue"] = this.invalidValue;
        super.toJSON(data);
        return data;
    }

    clone(): ResultError {
        const json = this.toJSON();
        let result = new ResultError();
        result.init(json);
        return result;
    }
}

export interface IResultError extends IValueObject {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;
}

export enum ResultErrorLevel {
    None = "None",
    Info = "Info",
    Warning = "Warning",
    NotFound = "NotFound",
    Error = "Error",
}

export class FrontendSettings implements IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;
    userInactivityAutoLogoutInMinutes?: number;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureClientId = _data["azureClientId"];
            this.azureAuthority = _data["azureAuthority"];
            this.azureApiScope = _data["azureApiScope"];
            this.userInactivityAutoLogoutInMinutes = _data["userInactivityAutoLogoutInMinutes"];
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureClientId"] = this.azureClientId;
        data["azureAuthority"] = this.azureAuthority;
        data["azureApiScope"] = this.azureApiScope;
        data["userInactivityAutoLogoutInMinutes"] = this.userInactivityAutoLogoutInMinutes;
        return data;
    }

    clone(): FrontendSettings {
        const json = this.toJSON();
        let result = new FrontendSettings();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettings {
    azureClientId?: string | undefined;
    azureAuthority?: string | undefined;
    azureApiScope?: string | undefined;
    userInactivityAutoLogoutInMinutes?: number;
}

export class UserProfileDto implements IUserProfileDto {
    userId?: number;
    login?: string | undefined;
    presenceApp?: boolean;
    nom?: string | undefined;
    prenom?: string | undefined;
    actif?: boolean;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.login = _data["login"];
            this.presenceApp = _data["presenceApp"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.actif = _data["actif"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["login"] = this.login;
        data["presenceApp"] = this.presenceApp;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["actif"] = this.actif;
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    userId?: number;
    login?: string | undefined;
    presenceApp?: boolean;
    nom?: string | undefined;
    prenom?: string | undefined;
    actif?: boolean;
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"] ? new Date(_data["checkTime"].toString()) : <any>undefined;
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): HealthCheckViewModel {
        const json = this.toJSON();
        let result = new HealthCheckViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        return data;
    }

    clone(): HealthCheckEntryViewModel {
        const json = this.toJSON();
        let result = new HealthCheckEntryViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export class ClientApiKey implements IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;

    constructor(data?: IClientApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.apiKey = _data["apiKey"];
            this.hashedApiKey = _data["hashedApiKey"];
        }
    }

    static fromJS(data: any): ClientApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["apiKey"] = this.apiKey;
        data["hashedApiKey"] = this.hashedApiKey;
        return data;
    }

    clone(): ClientApiKey {
        const json = this.toJSON();
        let result = new ClientApiKey();
        result.init(json);
        return result;
    }
}

export interface IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface Middleware {
  pre?(context: RequestInit): Promise<RequestInit | void>;

  post?(response: Response): Promise<Response | void>;
}

export interface Configuration {
  basePath?: string; // override base path
  apiKey?: string; // parameter for apiKey security
  apiKeyPromise?: () => Promise<string>;
  headers?: HTTPHeaders; //header params we want to use on every request
  credentials?: RequestCredentials; //value for the credentials param we want to use on each request
  middlewares?: Middleware[];
}

export type Json = any;
export type HTTPMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };